import { useMutation } from '@tanstack/react-query';

import { MessagingTransport } from '../provider/context';
import { useMessagingDeps } from '../provider/use-messaging-deps';
import { MessagingAuthRequest } from '../types/messaging';

// Ported from register's src/queries/messaging/auth.ts.
// `authenticate` is a plain function (not a hook), so it can't read the DI
// context itself — it takes `transport` as an argument. Hook callers
// (useMessagingAuthMutation here, and the Pusher/Ably auth hooks) grab
// `transport` from useMessagingDeps() and pass it in.
export async function authenticate<T>(transport: MessagingTransport, payload: MessagingAuthRequest) {
  return await transport<T>(`messaging/auth/${payload.ChannelType}`, payload);
}

export function useMessagingAuthMutation<T>(payload: MessagingAuthRequest) {
  const { transport } = useMessagingDeps();

  return useMutation({
    mutationKey: ['Messaging-Auth', payload.Provider, payload.ChannelType],
    mutationFn: () => authenticate<T>(transport, payload),
  });
}
